<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock">
                        <div class="row"></div>

                        <div class="row question-bank-row">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-lg-7 col-xl-8 create-question-scroll">
                                        <div class="heading mt-3">
                                            <div class="col-md-12">
                                                <vs-breadcrumb align="left" :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard',
                    },
                    {
                      title: 'Employee Registration',
                      url: '/#/dashboard/Admin/employeeReg',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                                            </div>
                                            <h3 class="text-secondary text-left">
                                                User Management / Employees
                                            </h3>
                                        </div>
                                        <!-- new form popup starts -->

                                        <b-card>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="table-responsive">
                                                            <table class="table table-hover table-responsive">
                                                                <!-- search -->
                                                                <input type="text" placeholder="Search ..." v-model="searchQuery" class="search_button form-control" @keyup.enter="filterData" @input="callSearch" />
                                                                <button class="clear_button2" @click="allEmployees">
                                                                    Search
                                                                </button>
                                                                <i v-if="searchQuery !== ''" class="material-icons close_icon2" @click="clearSearch">close</i>
                                                                <Pagination :current-page="currentPage" :record-limit="recordLimit" :total-counts="totalCounts" @prev-page="prevPage" @next-page="nextPage" @go-to-page="goToPage" />
                                                                <div class="page-count">
                                                                    {{((currentPage-1)*50)+items.length}}
                                                                    Records out of
                                                                    {{this.totalCounts}}
                                                                </div>
                                                                <tr>
                                                                    <th>Sr#</th>
                                                                    <th>Employee Name</th>
                                                                    <th>Code</th>
                                                                    <th>Department</th>
                                                                    <th>Role</th>
                                                                    <th>Email</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                                <tr v-for="(item, index) in items" v-bind:key="item.id">
                                                                    <td>{{index+1+offSet}}</td>
                                                                    <td class="text-capitalize">
                                                                        {{item.name}}
                                                                    </td>
                                                                    <td>{{item.code}}</td>
                                                                    <td v-if="item.departments != null" class="text-capitalize">
                                                                        {{item.departments.title}}
                                                                    </td>
                                                                    <td v-else>N/A</td>
                                                                    <td class="text-capitalize" v-if="item.roles != null">
                                                                        {{item.roles.title}}
                                                                    </td>
                                                                    <td v-else>N/A</td>
                                                                    <td>{{item.username}}</td>
                                                                    <td v-if="isPermission == true">
                                                                        <a @click="editRecord(item.id)">
                                                                            <vs-icon class="mr-0" icon="edit" style="color:#007bff;font-size:17px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                        </a>
                                                                        <a @click="deleteRecord(item.id)">
                                                                            <vs-icon class="mr-0" icon="delete" style="color:#ff0000c7;font-size:17px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-card>
                                        <!-- new form popup ends -->
                                    </div>
                                    <div class="col-lg-5 col-xl-4 order-first order-lg-2 show-question-scroll create-right">
                                        <template v-if="isForm">
                                            <h6 class="mt-4">Add New User</h6>
                                            <form @submit.prevent="regFormSubmit">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <!-- floating input starts -->
                                                        <div class="col-md-6 col-lg-12 mt-3">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="name" type="text" placeholder=" " autocomplete="off" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Employee Name
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12 mt-3">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="code" type="text" placeholder=" " autocomplete="off" />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">code</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Employee Code (This will use as password)
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>
                                                                Department / Section
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="department" :searchable="true">
                                                                <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>
                                                                Designation
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="designation" :searchable="true">
                                                                <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>
                                                                Role
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="role" :searchable="true">
                                                                <option v-for="(item,index) in rolesArr" :key="index" :value="item.id" class="text-capitalize">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                      

                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-mask="'(9999)-9999999'" v-model="contactNo" type="text" placeholder=" " autocomplete="off" />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">call</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Contact Number
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="username" type="email" placeholder=" " autocomplete="off" />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">email</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Email (This will use as a username for
                                                                    login)
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>

                                                          <!-- Gender starts -->
                                                          <div class="col-sm-2 mt-4 col-lg-12" style="padding-left: 5px;display: inline-flex;">
                                                            <label class="col-sm-2 col-form-label">
                                                                Gender
                                                                <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                                                            </label>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                                            </div>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                                            </div>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                                            </div>
                                                        </div>
                                                        <!-- Gender ends -->
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-12">

                                                            <button class="btn btn-primary save-btn" type="submit" style="background-color: #07a7e1c2;">
                                                                Register
                                                            </button>
                                                            <!-- add button ends -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </template>
                                        <!-- Edit form starts here -->
                                        <temp v-if="isEditForm">
                                            <h6 class="mt-4">Edit User</h6>
                                            <form @submit.prevent="submitEditForm">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <!-- floating input starts -->
                                                        <div class="col-md-6 col-lg-12 mt-3">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="name" type="text" placeholder=" " @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Employee Name
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12 mt-3">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="code" type="text" placeholder=" " />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">code</i>
                                                                </span>
                                                                <label class="lbl-label">
                                                                    Employee Code (This will use as password)
                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>Department / Section</label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="department" :searchable="true">
                                                                <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>Designation</label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="designation" :searchable="true">
                                                                <option v-for="(item,index) in designationArr" :key="index" :value="item.id">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                        <div class="col-sm-6 col-lg-12">
                                                            <label>Role</label>
                                                            <selectize id="select-state" v-model="role" class="text-capitalize" :searchable="true">
                                                                <option v-for="(item,index) in rolesArr" :key="index" :value="item.id">
                                                                    {{item.title}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                       

                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-mask="'(9999)-9999999'" v-model="contactNo" type="text" placeholder=" " />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">call</i>
                                                                </span>
                                                                <label class="lbl-label">Contact Number</label>
                                                            </div>
                                                        </div>

                                                        <!-- floating input ends -->
                                                        <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                                                            <div class="floating-label">
                                                                <input class="floating-input form-control" v-model="username" type="email" placeholder=" " style="text-transform:none !important" />

                                                                <span class="lbl-label" style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;">
                                                                    <i class="material-icons" style="font-size: 20px;">email</i>
                                                                </span>
                                                                <label class="lbl-label">Email (This will use as a username for
                                                                    login)</label>
                                                            </div>
                                                        </div>

                                                         <!-- Gender starts -->
                                                         <div class="col-sm-4 mt-4 col-lg-12" style="padding-left: 5px;display: inline-flex;">
                                                            <label class="col-sm-4 col-form-label">Gender</label>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                                            </div>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                                            </div>
                                                            <div style="margin: 7px 6px 2px 6px">
                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                                            </div>
                                                        </div>
                                                        <!-- Gender ends -->
                                                    </div>
                                                </div>
                                                <input type="hidden" v-model="userId" />
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-lg-12">
                                                            <!-- add button starts-->
                                                            <b-button pill type="submit" class="save-btn" variant="primary">Update</b-button>
                                                            <b-button pill v-if="!isForm" @click="closeEditForm" variant="outline-info">Cancel</b-button>
                                                            <!-- add button ends -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </temp>
                                        <!-- // End of Edit form -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Pagination from '../../../components/Pagination.vue'
import "bootstrap/dist/css/bootstrap.css";
import Selectize from "vue2-selectize";


// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        searchQuery: "",
        isSidebar: false,
        isForm: true,
        isEditForm: false,
        isFormData: false,
        selected: "",
        donerSelected: "",
        donersettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        name: "",
        code: "",
        rolesArr: [],
        departmentArr: [],
        designationArr: [],
        gender: "",
        contactNo: "",
        username: "",
        role: "",
        department: "",
        designation: "",
        createdAt: "",
        userId: "",
        isPermission: false,
        items: []
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        if (localStorage.getItem("isPermission") == "admin") {
            this.isPermission = true;
        }
        // Set the initial number of items
        // this.totalRows = this.items.length;
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/roles/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.rolesArr = response.data;
            });
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.departmentArr = response.data;
            });
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.designationArr = response.data;
            });
        this.allEmployees();
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Selectize,
        Pagination
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        allEmployees: function allEmployees() {
            this.openLoading();
            axios
                .post(process.env.VUE_APP_BASE_PATH + "/admin/employees/get", {
                    "searchText": this.searchQuery,
                    "offSet": this.offSet,
                })
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data.users;
                    this.totalCounts = response.data.totalCount;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.currentOffset;
                });
        },

        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/admin/user/" + id + "/edit")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.name = response.data.name;
                        this.code = response.data.code;
                        this.gender = response.data.gender;
                        this.contactNo = response.data.contactNo;
                        this.username = response.data.username;
                        if (response.data.roles && response.data.roles.id != null) {
                            this.role = response.data.roles.id;
                        } else {
                            this.role = "";
                        }

                        if (
                            response.data.departments &&
                            response.data.departments.id != null
                        ) {
                            this.department = response.data.departments.id;
                        } else {
                            this.department = "";
                        }

                        if (
                            response.data.designations &&
                            response.data.designations.id != null
                        ) {
                            this.designation = response.data.designations.id;
                        } else {
                            this.designation = "";
                        }
                        this.userId = id;
                        // this will scrollTop to edit form
                        window.scrollTo(0, 0);
                    }
                });
        },

        regFormSubmit(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.department) {
                this.inValid.push("Department is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation is required.");
            }
            if (!this.role) {
                this.inValid.push("Role of the employee is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.username) {
                this.inValid.push("An Email address is required.");
            }
            var phone_no1 = this.contactNo;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                let phone = phone_no1.replace(/_/g, "");
                if (phone < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH + "/admin/registration/employee", {
                            name: this.name,
                            code: this.code,
                            department: this.department,
                            designation: this.designation,
                            role: this.role,
                            gender: this.gender,
                            contactNo: this.contactNo,
                            username: this.username
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been Added successfully!");
                            self.resetForm();
                            self.allEmployees();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },

        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.department) {
                this.inValid.push("Department is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation is required.");
            }
            if (!this.role) {
                this.inValid.push("Role of the employee is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.username) {
                this.inValid.push("An Email address is required.");
            }
            var phone_no1 = this.contactNo;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == "") {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                let phone = phone_no1.replace(/_/g, "");
                if (phone < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/admin/user/update", {
                        name: this.name,
                        code: this.code,
                        department: this.department,
                        designation: this.designation,
                        role: this.role,
                        gender: this.gender,
                        contactNo: this.contactNo,
                        username: this.username,
                        id: this.userId
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.isForm = true;
                            self.isEditForm = false;
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allEmployees();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/employee/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allEmployees();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        resetForm() {
            this.name = "";
            this.code = "";
            this.gender = "";
            this.contactNo = "";
            this.username = "";
            this.role = "";
            this.department = "";
            this.designation = "";
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.allEmployees();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.allEmployees();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.allEmployees();
        },
        filterData() {
            this.currentPage = 1
            this.offset = 0
            this.allEmployees();
        },
        clearSearch() {
            this.currentPage = 1
            this.offSet = 0
            this.searchQuery = ""
            this.allEmployees();
        },
        callSearch() {
            if (this.searchQuery.length == 0) {
                this.allEmployees();
            }
        }
    },

};
</script>

<style scoped>
@media only screen and (max-width: 992px) {
    .question-bank-row {
        height: 92vh;
         overflow: scroll !important;
    }

    .create-question-scroll {
        height: initial !important;
        overflow: hidden !important;
    }

    .show-question-scroll {
        height: initial !important;
        overflow: hidden !important;
    }
}

.question-bank-row {
    height: 92vh;
    overflow: hidden;
}

.create-question-scroll {
    height: 100vh;
    overflow: auto;
}

.show-question-scroll {
    height: 92vh;
    overflow: auto;
}

#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #ffffff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.display-table li {
    float: left;
    padding: 5px 5px;
}

.display-table li a {
    cursor: inherit;
    font-size: 14px;
    display: block;
    color: #747679;
    text-align: center;
    padding: 5px;
    text-decoration: none;
    background-color: #f1f1f1;
}

.tbl-head th {
    font-weight: 400 !important;
    color: rgba(7, 167, 225, 0.61);
}

.display-table {
    /* margin-bottom: 0px !important; */
    color: #8e8e8e;
}

.display-table th,
.display-table td {
    padding: 5px 10px !important;
    /* border: 1px dotted #07a7e14f; */
}

.search_button {
    position: relative
}

.clear_button2 {
    position: absolute;
    right: 15px;
    height: 38px;
    top: 0px;
    width: 80px;
    border-radius: 5px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: #ffffff;
    font-size: 15px;
}

.close_icon2 {
    position: absolute;
    right: 100px;
    top: 8px;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 24px !important;
}

.page-count {
    text-align: end;
    font-size: 15px;
    color: #06a6e0;
}
</style>
